<template>
  <div>
    <h1 class="common__main-title">Mail Tutors</h1>

    <div v-if="stage === 'template'" id="page-select-template">
      <h4>1. Select template</h4>
      <hr class="mb-4">
      <SelectMailTemplate mode="tutor" v-model="template" @next="toTutorsStage" />
    </div>

    <div v-if="stage === 'tutors'" id="page-select-tutors">
      <h4>2. Extract tutors condition</h4>
      <hr class="mb-4">
      <SelectTutors v-model="tutorsConditions"
        @back="stage = 'template'" @next="stage = 'mail'" />
    </div>

    <div v-if="stage === 'mail'" id="page-input-mail-contents">
      <h4>3. Edit email contents</h4>
      <hr class="mb-4">
      <InputMailContents v-model="mailContents" :name="template.name"
        @back="stage = 'tutors'" @next="stage = 'confirm'" />
    </div>

    <div v-if="stage === 'confirm'" id="page-confirm">
      <h4 class="mb-4">4. Confirm &amp; send mail</h4>

      <div class="row mb-4">
        <div class="col">
          <h5>Template</h5>
          <hr class="mt-0">
          <div class="row">
            <div class="form-group col-4">
              <label>Name</label>
              <div>{{ template.name }}</div>
            </div>
            <div class="form-group col-4">
              <label>Notification type</label>
              <div>{{ template.notification | notificationType }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <h5>Tutors condition</h5>
          <hr class="mt-0">
          <h6>Conditions</h6>
          <div class="row">
            <SelectTutors v-model="tutorsConditions" :isConfirm="true"
              @back="stage = 'template'" @next="stage = 'mail'" />
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <h5>Email contents</h5>
          <hr class="mt-0">
          <div class="row">
            <div class="form-group col">
              <label>Send date</label>
              <div v-if="mailContents.isImmediately">Immediately</div>
              <div v-else>{{ mailContents.datetime.format('YYYY/MM/DD HH:mm') }}</div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col">
              <label>Subject</label>
              <div>{{ mailContents.subject }}</div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col">
              <label>Text</label>
              <div style="white-space:pre-wrap;">{{ mailContents.body }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <b-button pill variant="secondary" class="mr-2" @click="stage = 'mail'">
          Back
        </b-button>
        <b-button pill variant="primary" @click="register">
          Register
        </b-button>
      </div>
    </div>

    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import { TutorConditions } from '@/store/tutors/types'
import { MailTemplate } from '@/store/mails/templates/types'
import {
  MailForRegisterToTutor,
  MailNotifications,
  mailNotificationType,
  Receiver,
} from '@/store/mails/types'
import SelectMailTemplate from '@/components/parts/mails/sendBulk/SelectMailTemplate.vue'
import SelectTutors from '@/components/parts/mails/sendBulk/SelectTutors.vue'
import InputMailContents, { MailContents } from '@/components/parts/mails/sendBulk/InputMailContents.vue'
import Loading from '@/components/parts/modal/Loading.vue'

type stageType = 'template' | 'tutors' | 'mail' | 'confirm'

export default Vue.extend({
  components: {
    SelectMailTemplate,
    SelectTutors,
    InputMailContents,
    Loading,
  },

  filters: {
    notificationType: (type: mailNotificationType): string => MailNotifications[type],
  },

  data: (): {
    stage: stageType
    template: MailTemplate|undefined
    tutorsConditions: TutorConditions|undefined
    mailContents: MailContents
    isLoading: boolean
  } => ({
    stage: 'template',
    template: undefined,
    tutorsConditions: undefined,
    mailContents: {
      datetime: null,
      isImmediately: false,
      subject: '',
      body: '',
    },
    isLoading: false,
  }),

  methods: {
    /**
     * チューター選択画面に移動（準備含む）
     */
    toTutorsStage() {
      this.mailContents.subject = this.template?.subject || ''
      this.mailContents.body = this.template?.body || ''
      this.stage = 'tutors'
    },
    /**
     * メール送信登録
     */
    async register() {
      if (this.isLoading) {
        return
      }
      this.isLoading = true

      try {
        const mail: MailForRegisterToTutor = {
          tutorConditions: this.tutorsConditions,
          sendDate: this.mailContents.isImmediately ? null : this.mailContents.datetime,
          subject: this.mailContents.subject,
          body: this.mailContents.body,
        }

        this.isLoading = false

        await this.$store.dispatch('registerMailToTutor', mail)
        this.isLoading = false
        await this.$bvModal.msgBoxOk('Success !')
        this.$router.push({ name: 'Mails' })
      } catch (error: any) {
        this.isLoading = false
        const message = _.has(error, 'response') ? error.response.data.message : error.message
        this.$bvModal.msgBoxOk(message)
      }
    },
  },
})
</script>

<style scoped>

</style>
